import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de médico). */
export type CertificadoRegularidadePjJob = ReportJob;
export type CertificadoRegularidadePjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Certificado de Regularidade PJ. */
@Injectable({ providedIn: 'root' })
export class CertificadoRegularidadePjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certificado-regularidade-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certificadoRegularidadePj;
}
